/** @jsx jsx */
import { array, bool, func, string } from 'prop-types'
import { isEmpty, isEqual } from 'lodash'
import { usePrevious } from '../../../hooks/usePrevious'
import { jsx } from 'theme-ui'
import { useEffect, useMemo } from 'react'
import { useFormikContext } from 'formik'
import { getRelatedQuestions } from '../../../utils/strategyBuilder'
import QuestionSection from '../../common/QuestionSection'
import { difference } from '../../../utils/globalHelper'

const Series = ({ questions, ...rest }) => {
  const { initialValues, values, setFieldValue } = useFormikContext()
  const relatedQuestions = getRelatedQuestions(questions)
  // get the related formik values
  const relatedValues = useMemo(() => {
    return Object.keys(relatedQuestions).map(key => {
      return { [key]: values[key] }
    })
  }, [values])

  const previousRelatedValues = usePrevious(relatedValues)

  useEffect(() => {
    if (!isEqual(initialValues, values)) {
      if (!isEmpty(relatedValues) && !isEmpty(previousRelatedValues)) {
        const changedValues = difference(relatedValues, previousRelatedValues)
        changedValues.forEach(value => {
          Object.entries(relatedQuestions).forEach(
            ([key, relatedQuestionIds]) => {
              const valueKey = Object.keys(value)[0]
              if (
                relatedQuestionIds.includes(valueKey) &&
                relatedValues[valueKey] !== ''
              ) {
                setFieldValue(key, '')
              }
            }
          )
        })
      }
    }
  }, [relatedValues])

  return questions.map(question => (
    <QuestionSection key={question.id} question={question} {...rest} />
  ))
}

Series.propTypes = {
  type: string,
  questions: array.isRequired,
  questionHasTooManyAnswers: bool,
  setQuestionHasTooManyAnswers: func,
}

export default Series
